import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import UserManagementStore from '../../stores/UserManagementStore';

class ManagePayeeCard extends Component {
  constructor(props) {
    super(props);

    this.delete = this.delete.bind(this);
    this.payeeNumber = this.payeeNumber.bind(this);
    this.onClick = this.onClick.bind(this);
    this.edit = this.edit.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);

    this.state = {
      isNominatedUser: UserManagementStore.isNominatedUser(),
    };
  }

  onClick(e) {
    if (e.target.localName !== 'button') {
      this.props.onClick(this.props.payee);
    }
  }

  checkKeyPress(e) {
    if (e.which === 40 || e.keyCode === 40) {
      if (document.activeElement.nextSibling) {
        document.activeElement.nextSibling.focus();
      }
    } else if (e.which === 38 || e.keyCode === 38) {
      if (document.activeElement.previousSibling) {
        document.activeElement.previousSibling.focus();
      }
    } else if (e.which === 13 || e.keyCode === 13) {
      this.onClick(e);
    }
  }

  delete(e) {
    if (e.target.localName === 'button' && e.target.innerHTML === 'Delete') {
      this.props.delete(this.props.payee);
    }
  }

  edit(e) {
    if (e.target.localName === 'button' && e.target.innerHTML === 'Edit') {
      MoveMoneyPayeeActionCreator.savePayeeInStore(this.props.payee);
      this.props.edit(this.props.payee);
    }
  }

  payeeNumber() {
    const accountNumber = this.props.payee.to_account.account_number;
    const sortcode = NumberUtils.formatSortCode(
      this.props.payee.to_account.sort_code
    );
    return (
      <div>
        <span>
          <span className="u-visually-hidden off-screen">
            Payee account Sort Code
          </span>
          {`${sortcode} | `}
        </span>
        <span>
          <span className="u-visually-hidden off-screen">
            Payee account number
          </span>
          {accountNumber}
        </span>
      </div>
    );
  }

  render() {
    const { isNominatedUser } = this.state;
    const activeNomineeClass = isNominatedUser
      ? ' account-card__payeename--nominated'
      : '';

    return !BrowserUtils.isTabletView() ? (
      this.props.payee.hasOwnProperty('display_name') &&
      this.props.payee.display_name !== '' ? (
        <li
          className="account-card account-card--payee"
          onClick={this.onClick}
          onKeyDown={this.checkKeyPress}
          aria-label={`Manage payee ${this.props.payee.display_name}`}
        >
          <dl className="account-card__data">
            <dt className="account-card__data__name">Payee nickname</dt>

            <dd
              className={`account-card__payeename${activeNomineeClass}`}
              id={this.props.payee.id}
            >
              {this.props.payee.display_name}
            </dd>
            {!isNominatedUser && (
              <dt className="account-card__data__name">Payee options</dt>
            )}
            {!isNominatedUser && (
              <dd
                className="account-card__options pull-right"
                role="presentation"
              >
                <button
                  className="c-btn c-btn--link"
                  onClick={this.edit}
                  id="edit1"
                  aria-label={`edit ${this.props.payee.display_name}`}
                >
                  Edit
                </button>
                <button
                  className="c-btn c-btn--link"
                  name="delete"
                  onClick={this.delete}
                  aria-haspopup="true"
                  id="delete1"
                  aria-label={`delete ${this.props.payee.display_name}`}
                >
                  Delete
                </button>
              </dd>
            )}
            <dt className="account-card__data__name">Payee account number</dt>
            <dd className="account-card__number">{this.payeeNumber()}</dd>
            <dt className="account-card__data__name">Payee reference</dt>
            <dd className="account-card__reference">
              {this.props.payee.reference}
            </dd>
          </dl>
        </li>
      ) : (
        <li
          className="account-card account-card--payee"
          onClick={this.onClick}
          onKeyDown={this.checkKeyPress}
          aria-label={`Manage payee ${this.props.payee.display_name}`}
        >
          <dl className="account-card__data">
            <dt className="account-card__data__name">Payee nickname</dt>

            <dd
              className={`account-card__payeename${activeNomineeClass}`}
              id={this.props.payee.id}
            >
              {this.props.payee.to_account.name}
            </dd>
            {!isNominatedUser && (
              <dt className="account-card__data__name">Payee options</dt>
            )}
            {!isNominatedUser && (
              <dd
                className="account-card__options pull-right"
                role="presentation"
              >
                <button
                  className="c-btn c-btn--link"
                  onClick={this.edit}
                  id="edit2"
                  aria-label={`edit ${this.props.payee.display_name}`}
                >
                  Edit
                </button>
                <button
                  className="c-btn c-btn--link"
                  name="delete"
                  onClick={this.delete}
                  aria-haspopup="true"
                  id="delete2"
                  aria-label={`delete ${this.props.payee.display_name}`}
                >
                  Delete
                </button>
              </dd>
            )}
            <dt className="account-card__data__name">Payee account number</dt>
            <dd className="account-card__number">{this.payeeNumber()}</dd>
            <dt className="account-card__data__name">Payee reference</dt>
            <dd className="account-card__reference">
              {this.props.payee.reference}
            </dd>
          </dl>
        </li>
      )
    ) : this.props.payee.hasOwnProperty('display_name') &&
      this.props.payee.display_name !== '' ? (
      <li
        className="account-card account-card--payee"
        onClick={this.onClick}
        onKeyDown={this.checkKeyPress}
        aria-label={`Manage payee ${this.props.payee.display_name}`}
      >
        <dl className="account-card__data">
          <dt className="account-card__data__name">Payee nickname</dt>
          <dd
            className={`account-card__payeename${activeNomineeClass}`}
            id={this.props.payee.id}
          >
            {this.props.payee.display_name}
          </dd>
          {!isNominatedUser && (
            <dt className="account-card__data__name">Payee options</dt>
          )}
          {!isNominatedUser && (
            <dd
              className="account-card__options pull-right"
              role="presentation"
            >
              <button
                className="c-btn c-btn--link"
                onClick={this.edit}
                id="edit3"
                aria-label={`edit ${this.props.payee.display_name}`}
              >
                Edit
              </button>
              <button
                className="c-btn c-btn--link"
                name="delete"
                onClick={this.delete}
                aria-haspopup="true"
                id="delete3"
                aria-label={`delete ${this.props.payee.display_name}`}
              >
                Delete
              </button>
            </dd>
          )}
          <dt className="account-card__data__name">Payee account number</dt>
          <dd className="account-card__number">{this.payeeNumber()}</dd>

          <dt className="account-card__data__name">Payee reference</dt>
          <dd className="account-card__reference">
            {this.props.payee.reference}
          </dd>
        </dl>
      </li>
    ) : (
      <li
        className="account-card account-card--payee"
        onClick={this.onClick}
        onKeyDown={this.checkKeyPress}
        aria-label={`Manage payee ${this.props.payee.display_name}`}
      >
        <dl className="account-card__data">
          <dt className="account-card__data__name">Payee nickname</dt>

          <dd
            className={`account-card__payeename${activeNomineeClass}`}
            id={this.props.payee.id}
          >
            {this.props.payee.to_account.name}
          </dd>
          {!isNominatedUser && (
            <dt className="account-card__data__name">Payee options</dt>
          )}
          {!isNominatedUser && (
            <dd
              className="account-card__options pull-right"
              role="presentation"
            >
              <button
                className="c-btn c-btn--link"
                onClick={this.edit}
                id="edit4"
                aria-label={`edit ${this.props.payee.display_name}`}
              >
                Edit
              </button>
              <button
                className="c-btn c-btn--link"
                name="delete"
                onClick={this.delete}
                aria-haspopup="true"
                id="delete4"
                aria-label={`delete ${this.props.payee.display_name}`}
              >
                Delete
              </button>
            </dd>
          )}
          <dt className="account-card__data__name" />
          <dd className="account-card__number">{this.payeeNumber()}</dd>
          <dt className="account-card__data__name">Payee reference</dt>
          <dd className="account-card__reference">
            {this.props.payee.reference}
          </dd>
        </dl>
      </li>
    );
  }
}

ManagePayeeCard.propTypes = {
  content: PropTypes.object,
  payee: PropTypes.object,
  delete: PropTypes.func,
  onClick: PropTypes.func,
  edit: PropTypes.func,
};

ManagePayeeCard.defaultProps = {
  content: {},
  payee: {},
};

export default ManagePayeeCard;
